'use client'
import { Card, CardContent } from '@mui/material'

export default function VitalSummary({ data, onCardClick }) {

  const vitals = [
    {
      label: 'Sleep',
      value: data?.sleepAvg ? `${data.sleepAvg.toFixed(1)} hrs` : '—',
      icon: '/icons/vital-reports/sleep.svg',
      bg: 'bg-blue-50',
    },
    {
      label: 'Breathing Rate',
      value: data?.respRateAvg ? `${data.respRateAvg.toFixed(0)} bpm` : '—',
      icon: '/icons/vital-reports/breathing.svg',
      bg: 'bg-purple-50',
    },
    {
      label: 'Heart Rate',
      value: data?.heartRateAvg ? `${data.heartRateAvg.toFixed(0)} bpm` : '—',
      icon: '/icons/vital-reports/heart.svg',
      bg: 'bg-purple-50',
    },
    {
      label: 'SO₂ Level',
      value: data?.oxygenAvg ? `${data.oxygenAvg.toFixed(0)}%` : '—',
      icon: '/icons/vital-reports/SO2.svg',
      bg: 'bg-red-50',
    },
    {
      label: 'Blood Pressure',
      value:
        data?.bp_Systolic && data?.bp_Diastolic
          ? `${data.bp_Systolic.toFixed(0)} / ${data.bp_Diastolic.toFixed(0)} mmHg`
          : '—',
      icon: '/icons/vital-reports/bloodpressure.svg',
      bg: 'bg-green-50',
    },
    {
      label: 'Temperature',
      value: data?.tempAvg ? `${data.tempAvg.toFixed(1)} °F` : '—',
      icon: '/icons/vital-reports/temprature.svg',
      bg: 'bg-purple-50',
    },
    {
      label: 'Glucose',
      value: data?.glucoseAvg ? `${data.glucoseAvg.toFixed(1)} mmol/L` : '—',
      icon: '/icons/vital-reports/glucose.svg',
      bg: 'bg-purple-50',
    },
    {
      label: 'Weight',
      value: data?.weightAvg ? `${data.weightAvg.toFixed(1)} lbs` : '—',
      icon: '/icons/vital-reports/weight.svg',
      bg: 'bg-teal-50',
    },
  ]

  return (
    <Card className="rounded-xl shadow-md">
      <CardContent>
        <h2 className="font-bold text-gray-700 mb-4 text-center text-xl">
          Vital Summary Snapshot
        </h2>
        <ul className="divide-y grid grid-cols-2">
          {vitals.map((item, i) => (
            <li
              key={i}
              onClick={() => onCardClick?.(item, i)}
              className={`
                flex items-center justify-between p-3 ${item.bg}
                cursor-pointer rounded-lg 
                hover:shadow-lg hover:scale-[1.02] 
                hover:bg-opacity-80 
                transition-transform duration-200 ease-in-out
  `           }
            >
              <div className="flex items-center gap-3">
                <img src={item.icon} alt={item.label} className="w-8 h-8 xl:w-14 xl:h-14" />

                <div className="flex items-center gap-2 w-fit">
                  <div className="w-0.5 bg-black h-10" />
                  <div className="flex flex-col">
                    <span className="text-sm xl:text-base !break-words text-gray-500 font-semibold">
                      {item.label}
                    </span>
                    {/* <span className="font-bold text-gray-800">
                      {item.value}
                    </span> */}
                  </div>
                </div>
              </div>
              {/* <div className="flex items-center gap-2 w-32">
                <div className="w-0.5 bg-black h-10" />
              </div> */}
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  )
}
